interface CookiePreferences {
  technical: boolean;
  analytics: boolean;
  advertising: boolean;
  consentDate: string;
}

const COOKIE_PREFERENCES_KEY = 'cookiePreferences';
const COOKIE_CONSENT_KEY = 'cookieConsent';
const COOKIE_CONSENT_DATE = 'cookieConsentDate';

export const cookieService = {
  // Obtener preferencias actuales
  getPreferences(): CookiePreferences | null {
    const stored = localStorage.getItem(COOKIE_PREFERENCES_KEY);
    return stored ? JSON.parse(stored) : null;
  },

  // Guardar nuevas preferencias
  savePreferences(preferences: Omit<CookiePreferences, 'consentDate'>): void {
    const fullPreferences: CookiePreferences = {
      ...preferences,
      consentDate: new Date().toISOString()
    };
    localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(fullPreferences));
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
  },

  // Obtener estado del consentimiento
  getConsentStatus(): 'accepted' | 'declined' | null {
    return localStorage.getItem(COOKIE_CONSENT_KEY) as 'accepted' | 'declined' | null;
  },

  // Rechazar todas las cookies
  declineAll(): void {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    localStorage.setItem(COOKIE_CONSENT_DATE, new Date().toISOString());
  },

  // Verificar si una categoría específica está permitida
  isCategoryAllowed(category: keyof Omit<CookiePreferences, 'consentDate'>): boolean {
    const preferences = this.getPreferences();
    const consentStatus = this.getConsentStatus();

    // Las cookies técnicas siempre están permitidas
    if (category === 'technical') return true;

    // Si no hay consentimiento, solo las técnicas están permitidas
    if (consentStatus !== 'accepted') return false;

    // Si hay preferencias guardadas, usar esas
    if (preferences) return preferences[category];

    // Si no hay preferencias pero hay consentimiento, permitir todo
    return true;
  },

  // Limpiar todas las cookies y preferencias
  clearAll(): void {
    localStorage.removeItem(COOKIE_PREFERENCES_KEY);
    localStorage.removeItem(COOKIE_CONSENT_KEY);
    localStorage.removeItem(COOKIE_CONSENT_DATE);
  }
}; 